<template>
  <div class="space-y-2">
    <p>
      We may update this Cookie Policy periodically to reflect changes in technology, legal requirements, or our operations.
    </p>
    <p>
      The latest version will always be posted on this page with an updated “Effective Date.”
    </p>
  </div>
</template>